class TranslateHttpLoader {
    constructor(http, prefix = "/assets/i18n/", suffix = ".json") {
        this.http = http;
        this.prefix = prefix;
        this.suffix = suffix;
    }
    /**
     * Gets the translations from the server
     */
    getTranslation(lang) {
        return this.http.get(`${this.prefix}${lang}${this.suffix}`);
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { TranslateHttpLoader };



//////////////////
// WEBPACK FOOTER
// ./~/@ngx-translate/http-loader/fesm2015/ngx-translate-http-loader.mjs
// module id = 839
// module chunks = 0